export { default } from './Welcome.component';
